<div class="main-box" *transloco="let t; prefix: 'fuelDashboard'">
  <div class="top-title">
    <h2>{{ t('modals.fuelCostBreakdown.title') }}</h2>
    <button type="button" (click)="closeModal()">
      <img src="assets/images-fuel/closeModalBtnIcon.svg" alt="icon-close" />
    </button>
  </div>
  <div class="inner-body">
    <div class="inner-row">
      <div class="row-left">
        <div class="card">
          <h3>{{ t('modals.fuelCostBreakdown.tableTitle') }}</h3>
          <div class="inner-box">
            <div class="title-button">
              <h4>{{ t('widgets.fuelCost') }}</h4>
            </div>
            <!-- <app-common-table [modalType]="'fuel-cost-breakdown'"></app-common-table> -->
            <div class="main-table fuel-breakdown">
              <table class="table">
                <thead>
                  <tr>
                    <th class="factor">{{ t('table.factor') }}</th>
                    <th class="last-month">
                      {{ t('table.lastMonth') }}<button class="filter-button">
                        <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                      </button>
                    </th>
                    <th class="this-month">
                      {{ t('table.thisMonth') }}<button class="filter-button">
                        <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                      </button>
                    </th>
                    <th class="change">
                      {{ t('table.change') }}<button class="filter-button">
                        <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="factor">
                      <p class="bold-text">{{ t('modals.fuelCostBreakdown.fuelTheftIncidents') }}</p>
                    </td>
                    <td class="last-month">
                      <p>{{ t('values.cases', { count: 5 }) }}</p>
                    </td>
                    <td class="this-month">
                      <p>{{ t('values.cases', { count: 4 }) }}</p>
                    </td>
                    <td class="change">
                      <p>+20%</p>
                    </td>
                  </tr>
                  <tr>
                    <td class="factor">
                      <p class="bold-text">{{ t('modals.fuelCostBreakdown.leakageSpillageReports') }}</p>
                    </td>
                    <td class="last-month">
                      <p>{{ t('values.cases', { count: 5 }) }}</p>
                    </td>
                    <td class="this-month">
                      <p>{{ t('values.cases', { count: 4 }) }}</p>
                    </td>
                    <td class="change">
                      <p>+20%</p>
                    </td>
                  </tr>
                  <tr>
                    <td class="factor">
                      <p class="bold-text">{{ t('modals.fuelCostBreakdown.unusualConsumptionPatterns') }}</p>
                    </td>
                    <td class="last-month">
                      <p>{{ t('values.cases', { count: 5 }) }}</p>
                    </td>
                    <td class="this-month">
                      <p>{{ t('values.cases', { count: 4 }) }}</p>
                    </td>
                    <td class="change">
                      <p>+20%</p>
                    </td>
                  </tr>
                  <tr>
                    <td class="factor">
                      <p class="bold-text">{{ t('modals.fuelCostBreakdown.tankRefillDiscrepancies') }}</p>
                    </td>
                    <td class="last-month">
                      <p>{{ t('values.litres', { value: '60' }) }}</p>
                    </td>
                    <td class="this-month">
                      <p>{{ t('values.litres', { value: '65' }) }}</p>
                    </td>
                    <td class="change">
                      <p>+8.33%</p>
                    </td>
                  </tr>
                  <tr>
                    <td class="factor">
                      <p class="bold-text">{{ t('modals.fuelCostBreakdown.idleFuelConsumption') }}</p>
                    </td>
                    <td class="last-month">
                      <p>{{ t('values.litres', { value: '10' }) }}</p>
                    </td>
                    <td class="this-month">
                      <p>{{ t('values.litres', { value: '9.5' }) }}</p>
                    </td>
                    <td class="change">
                      <p>-5%</p>
                    </td>
                  </tr>
                  <tr>
                    <td class="factor">
                      <p class="bold-text">{{ t('modals.fuelCostBreakdown.unauthorizedUsageIncidents') }}</p>
                    </td>
                    <td class="last-month">
                      <p>{{ t('values.cases', { count: 5 }) }}</p>
                    </td>
                    <td class="this-month">
                      <p>{{ t('values.cases', { count: 4 }) }}</p>
                    </td>
                    <td class="change">
                      <p>+20%</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row-right">
        <div class="card grap-card increase">
          <div class="card-body p-0">
            <div class="grap-up d-flex align-items-center justify-content-between">
              <div class="graph-text">
                <h4>{{ t('charts.fuelCostRandsPerLitre') }}</h4>
                <p>
                  {{ t('values.randsPerLitre', { value: '22.4' }) }} <strong>+19.29%</strong>
                  <i><img src="./assets/images-fuel/upgreen-icon.svg" alt="down-icon" /></i>
                </p>
              </div>
              <div class="button-wrapper">
                <div class="common-drop-down no-filter dropdown">
                  <button type="button" id="dropdown-button" data-bs-toggle="dropdown" aria-expanded="false">
                    <img src="assets/images-fuel/threeDotBtnIcon.svg" alt="graph-icon" />
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdown-button">
                    <li><a class="dropdown-item">{{ t('units.litres') }}</a></li>
                    <li>
                      <a class="dropdown-item">{{ t('units.litresPerKilometer') }}</a>
                    </li>
                    <li>
                      <a class="dropdown-item">{{ t('units.litresPer100km') }}</a>
                    </li>
                    <li>
                      <a class="dropdown-item">{{ t('units.randsPerLitre') }}</a>
                    </li>
                  </ul>
                </div>
                <button (click)="fullChartClick()" class="graph-button">
                  <img src="assets/images-fuel/grapBtnIcon.svg" alt="graph-icon" />
                </button>
              </div>
            </div>
            <div class="grap-down">
              @defer (on timer(200ms)) {
              <app-multi-line-chart [data]="fuelCostChartData" [chartConfig]="fuelCostChartConfig" [yConfig]="yConfig"
                [margin]="{ top: 20, right: 5, bottom: 0, left: 35, height: 159 }" />
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>